<template>
  <div class="login-page">
    <img class="bg-img" src="https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png" alt="" />

    <div class="overlay">
      <van-nav-bar class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
        <template #right>
          <div class="language" @click="$router.push('/language')">
            <img src="/img/mine/nav10.png" />
          </div>
        </template>
      </van-nav-bar>

      <div class="content">
        <div class="hero-title">{{ $t("auth.login") }}</div>
        <div class="hero-subtitle">Welcome back, start exploring</div>

        <div class="glass-card">
          <van-field
              v-model="username"
              class="field"
              :placeholder="$t('auth.username_place')"
          />

          <van-field
              v-model="password"
              :type="passwordType"
              class="field"
              :placeholder="$t('auth.pwd_place')"
          >
            <template slot="right-icon">
              <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
              />
            </template>
          </van-field>

          <div class="forgot" @click="toForgetPwd">
            {{ $t("auth.forgetpwd") }}?
          </div>

          <van-button class="login-btn" block @click="doLogin()">
            {{ $t("auth.login") }}
          </van-button>

          <div class="register" @click="toRegister()">
            {{ $t("auth.no_account") }}
          </div>

          <!-- Android 和 iPhone 均打开同一个 App 下载页 -->
          <div class="app-download">
            <div class="app-download-title">{{ downloadLabels.title }}</div>
            <div class="app-download-buttons">
              <a class="app-download-btn" :href="appDownloadUrl" :aria-label="downloadLabels.android">
                <svg class="app-download-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M7 5 5.5 2.5M17 5l1.5-2.5M4 12a8 8 0 0 1 16 0v7H4zM8 19v2M16 19v2M1.5 12v6M22.5 12v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                  <circle cx="8.5" cy="9.5" r="1" fill="currentColor" />
                  <circle cx="15.5" cy="9.5" r="1" fill="currentColor" />
                </svg>
                <span class="app-download-text"><strong>Android</strong><small>{{ downloadLabels.download }}</small></span>
              </a>
              <a class="app-download-btn" :href="appDownloadUrl" :aria-label="downloadLabels.ios">
                <svg class="app-download-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M16.7 12.4c0-2.2 1.8-3.3 1.9-3.4-1.1-1.6-2.7-1.8-3.3-1.8-1.4-.1-2.7.8-3.4.8-.7 0-1.8-.8-3-.8-1.6 0-3 .9-3.8 2.2-1.6 2.7-.4 6.8 1.1 9 .8 1.1 1.6 2.2 2.8 2.2 1.1-.1 1.5-.7 2.9-.7s1.8.7 3 .6c1.2 0 1.9-1.1 2.6-2.2.9-1.3 1.3-2.5 1.3-2.6-.1 0-2.1-.8-2.1-3.3ZM14.3 5.8c.6-.8 1.1-1.9 1-3-.9 0-2.1.6-2.8 1.4-.6.7-1.1 1.9-1 2.9 1.1.1 2.2-.5 2.8-1.3Z" fill="currentColor" />
                </svg>
                <span class="app-download-text"><strong>iPhone</strong><small>{{ downloadLabels.download }}</small></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: "zh",
      password: this.inputValue,
      passwordType: "password",
      appDownloadUrl: "https://app.goloves.top/",
    };
  },
  computed: {
    downloadLabels() {
      const locale = String((this.$i18n && this.$i18n.locale) || this.lang || "zh")
          .toLowerCase()
          .replace(/_/g, "-");
      if (/^(en|en-)/.test(locale)) {
        return { title: "Download the app", download: "Download", android: "Download for Android", ios: "Download for iPhone" };
      }
      if (/^(ja|jp)(-|$)/.test(locale)) {
        return { title: "アプリをダウンロード", download: "ダウンロード", android: "Android 版をダウンロード", ios: "iPhone 版をダウンロード" };
      }
      if (/^(ko|kr)(-|$)/.test(locale)) {
        return { title: "앱 다운로드", download: "다운로드", android: "Android용 다운로드", ios: "iPhone용 다운로드" };
      }
      if (/^(zh-tw|zh-hk|zh-mo|zh-hant|tw|hk|cht|ft)(-|$)/.test(locale)) {
        return { title: "下載 App", download: "立即下載", android: "下載 Android 版", ios: "下載 iPhone 版" };
      }
      return { title: "下载 App", download: "立即下载", android: "下载 Android 版", ios: "下载 iPhone 版" };
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "zh";
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    toForgetPwd() {
      this.$router.push("/forgetPassword");
    },
    doLogin() {
      if (!this.username) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #000;
}
.login-page * { box-sizing: border-box; }
.bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  z-index: 1;
}
.overlay {
  position: relative;
  z-index: 2;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.16) 0%, rgba(55, 32, 65, 0.28) 38%, rgba(94, 58, 102, 0.82) 100%);
}
.overlay::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48%;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(118, 80, 130, 0) 0%, rgba(118, 80, 130, 0.38) 32%, rgba(93, 58, 100, 0.88) 100%);
}
.content {
  position: relative;
  z-index: 3;
  width: 100%;
  padding: 205px 32px 48px;
  padding-bottom: calc(48px + env(safe-area-inset-bottom, 0px));
}
.hero-title {
  color: #fff;
  font-size: 76px;
  font-weight: 900;
  line-height: 0.95;
  letter-spacing: 1px;
  text-shadow: 0 5px 18px rgba(0, 0, 0, 0.38);
}
.hero-subtitle {
  margin-top: 12px;
  margin-bottom: 42px;
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.15;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
}
.glass-card {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 46px 32px 36px;
  border-radius: 34px;
  background: rgba(105, 82, 108, 0.58);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 38px 78px rgba(35, 20, 42, 0.52), 0 16px 34px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
.glass-card::after {
  content: "";
  position: absolute;
  left: 7%;
  right: 7%;
  bottom: -30px;
  height: 42px;
  border-radius: 50%;
  background: rgba(45, 25, 52, 0.46);
  filter: blur(26px);
  z-index: -1;
}
.field { margin-bottom: 22px; border-radius: 12px; overflow: hidden; background: #fff; }
::v-deep .van-cell {
  height: 72px !important;
  min-height: 72px !important;
  padding: 0 22px !important;
  border-radius: 12px !important;
  background: #fff !important;
}
::v-deep .van-field__body { height: 72px !important; }
::v-deep .van-field__control {
  height: 72px !important;
  line-height: 72px !important;
  color: #111 !important;
  font-size: 20px !important;
  font-weight: 500;
  text-align: left !important;
}
::v-deep .van-field__control::placeholder,
::v-deep input::placeholder { color: #c6c6c6 !important; font-size: 22px !important; font-weight: 500; }
::v-deep .van-field__right-icon { display: flex; align-items: center; height: 72px; }
::v-deep .van-field__right-icon .van-icon { color: #999; font-size: 26px !important; }
.forgot { margin: 8px 8px 36px 0; color: #fff; font-size: 18px; font-weight: 500; line-height: 1; text-align: right; }
.login-btn {
  width: 100% !important;
  height: 76px !important;
  border: none !important;
  border-radius: 40px !important;
  background: linear-gradient(90deg, #f36b68 0%, #e43e83 100%) !important;
  color: #fff !important;
  font-size: 28px !important;
  font-weight: 900 !important;
  box-shadow: 0 18px 36px rgba(226, 63, 130, 0.38), 0 8px 18px rgba(0, 0, 0, 0.16);
}
::v-deep .van-button__text { font-size: 28px !important; font-weight: 900 !important; }
.register { margin-top: 32px; color: #fff; font-size: 28px; font-weight: 500; line-height: 1.2; text-align: center; }
.language { width: 46px; height: 46px; border-radius: 50%; overflow: hidden; }
.language img { width: 100%; height: 100%; object-fit: cover; }
::v-deep .van-nav-bar { position: relative; z-index: 3; background: transparent !important; }
::v-deep .van-nav-bar::after { display: none !important; }
::v-deep .van-nav-bar__content { height: 88px !important; }
::v-deep .van-nav-bar .van-icon { font-size: 32px !important; color: #fff !important; }

/* App 下载入口，匹配原页面玻璃卡片风格 */
.app-download {
  margin-top: 30px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.app-download-title {
  margin-bottom: 18px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
}
.app-download-buttons { display: flex; gap: 18px; }
.app-download-btn {
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 84px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.18s;
}
.app-download-btn:active { background: rgba(255, 255, 255, 0.23); }
.app-download-btn:focus-visible { outline: 2px solid #fff; outline-offset: 4px; }
.app-download-icon { display: block; width: 34px; height: 34px; flex-shrink: 0; }
.app-download-text { display: flex; flex-direction: column; min-width: 0; gap: 5px; }
.app-download-text strong { font-size: 22px; font-weight: 600; line-height: 1.2; }
.app-download-text small { color: rgba(255, 255, 255, 0.85); font-size: 16px; line-height: 1.4; overflow-wrap: anywhere; }
@media screen and (max-width: 750px) {
  .content { padding-top: 205px; padding-left: 32px; padding-right: 32px; }
  .hero-subtitle { font-size: 24px; margin-bottom: 42px; }
  .glass-card { padding: 46px 32px 36px; border-radius: 34px; }
}
@media (prefers-reduced-motion: reduce) {
  .app-download-btn { transition: none; }
}
</style>
